/* @ngInject */
export class ToggleBoxController {
  /* @ngInject */
  constructor () {
    this.notToggleable = false

  }

  $onInit() {

    console.log('ToggleBoxController : init')

    this.isOpen = this.startOpen
    console.log('ToggleBoxController isOpen', this.isOpen)
  }

  toggle () {
    if(this.notToggleable) // boites simples, non toggleables
        return;
    this.isOpen = !this.isOpen
  }

}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/ToggleBox/toggle-box.controller.js